import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper
} from '@mui/material';
import { MarketsManagement } from '../../components/admin/MarketsManagement';
import { ReportsAnalytics } from '../../components/admin/ReportsAnalytics';
import { useCurrentUser } from '../../hooks/useApi';
import { Navigate, useLocation } from 'react-router-dom';

export const ReportsAdmin: React.FC = () => {
  const { data: user } = useCurrentUser();
  const location = useLocation();
  
  // Map hash values to tab indices
  const getTabFromHash = (hash: string): number => {
    switch (hash) {
      case '#analytics':
        return 1;
      default:
        return 0; // Markets tab by default (includes #markets and empty hash)
    }
  };

  const [activeTab, setActiveTab] = useState(() => getTabFromHash(location.hash));

  // Update tab when hash changes
  useEffect(() => {
    const tabIndex = getTabFromHash(location.hash);
    setActiveTab(tabIndex);
  }, [location.hash]);

  // Redirect if user doesn't have admin permission
  if (!user?.permissions?.includes('market_compass.admin')) {
    return <Navigate to="/" replace />;
  }

  return (
    <Box>
      <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>
          <Typography variant="h4" component="h1" gutterBottom>
            Reports Administration
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Manage markets and view analytics
          </Typography>
        </Box>
        
      </Box>

      <Paper sx={{ mb: 3 }}>
        <Tabs
          value={activeTab}
          onChange={(e, v) => {
            setActiveTab(v);
            // Update URL hash based on selected tab
            const hashes = ['#markets', '#analytics'];
            window.location.hash = hashes[v] || '';
          }}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Markets" />
          <Tab label="Analytics" />
        </Tabs>
      </Paper>

      <Box sx={{ mt: 3 }}>
        {activeTab === 0 && <MarketsManagement />}
        {activeTab === 1 && <ReportsAnalytics />}
      </Box>
    </Box>
  );
};